import React from 'react';
export function Footer() {
  return <footer className="w-full border-t border-white/10 bg-navy-deep" data-id="element-96" data-mp="32wd2qgad7ltj">
      <div className="mx-auto max-w-3xl px-5 py-12 text-center" data-id="element-97" data-mp="3ggarlxr3gh6i">
        <h3 className="font-display text-2xl text-white" data-id="element-98" data-mp="32nuh6bvv5gvk">Bollywood Class Ready</h3>
        <p className="mx-auto mt-2 max-w-md text-sm text-white/70" data-id="element-99" data-mp="32m1awxp5wyo3">
          The 8-Count Studio System: because your next class shouldn&apos;t
          start from a blank page.
        </p>
        <div className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-2.5 text-[13px] text-white/75" data-id="element-100" data-mp="3ucxndx7b91au">
          <a href="mailto:help@iclcollective.com" className="transition-colors duration-150 hover:text-white hover:underline" data-id="element-101" data-mp="36d3cxfoatnb">help@iclcollective.com</a>
        </div>
        <p className="mx-auto mt-7 max-w-2xl border-t border-white/15 pt-5 text-xs leading-relaxed text-white/55" data-id="element-102" data-mp="3qc3z32pyhkhf">
          Bollywood Class Ready is an educational resource for dance
          instructors. It is not medical advice: participants with pain,
          injury or pregnancy should be referred to a health professional, and
          instructors are responsible for safe progressions in their own
          setting. Music is not included: use tracks you are licensed to play.
          The styles in this pack come from living Indian dance and folk
          traditions and are presented with credit to their origins.
          &quot;Bollywood&quot; is used as a descriptive term. Not affiliated
          with or endorsed by any film studio, dance school or certification
          body. © Bollywood Class Ready 2026. All rights reserved.
        </p>
      </div>
    </footer>;
}